import { useDesktopNavigation } from '@components/navbar/desktop/DesktopNavigationContext'
import { AnalyticsIcon } from '@components/navbar/icons'
import useHasSystemRole from '@hooks/useHasSystemRole.ts'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { routesFactory } from '@utils/routes.ts'

import NavItem from './NavItem'

function AnalyticsNavItem() {
  const { t } = useTypedTranslation()
  const { storeId, scanId, isActive } = useDesktopNavigation()

  const isDeveloper = useHasSystemRole('DEVELOPER')
  if (!isDeveloper) return null

  return (
    <NavItem
      to={routesFactory.analytics(storeId, scanId)}
      label={t('analytics.title')}
      isActive={isActive('analytics')}
      icon={<AnalyticsIcon size={20}/>}
    />
  )
}

export default AnalyticsNavItem

